import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { TextView } from "src/core/ui/text.view";

@observer
export class AllotmentRangeDailyView extends React.Component<AllotmentRangeDailyListViewProps, any> {
	columns: Column[] = [
		{
			key: 'dateText',
			dataIndex: 'dateText',
			title: 'Date'

		},
		{
			key: 'dailyLimit',
			dataIndex: 'dailyLimit',
			title: 'Daily Limit',
			editable: (text: string, record: AllotmentRangeDailyItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return <TextView mode='edit' label={null}
						value={record.dailyLimit}
						onChanged={newVal => {
							record.dailyLimit = newVal;
						}} />
				}
				return record.dailyLimit || "";
			}
		}
	];

	public render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<DataTableView
				mode={this.props.mode}
				setBusy={this.props.setBusy}
				columns={this.columns}
				model={this.props.model}
				hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range-daily/list/allotment-range-daily-list.view.tsx